import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button,Card, CardContent, CardHeader,Fab, List, ListItem, ListItemText, IconButton, Divider, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DentistModal from '../dentistModal';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import SuccessMessage from "../../components/successMessage";
import ErrorMessage from "../../components/errorMessage";
import Loading from '../../components/loading';
import AddIcon from '@mui/icons-material/Add';


function DentistListMobile() {
    const navigate = useNavigate();

    const [dentists, setDentists] = useState([]);
    const [isLoading, setLoading] = useState(true);
    
    const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
    
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedDentist, setSelectedDentist] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedDentistId, setSelectedDentistId] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const getDentists = useCallback(() => {
        setLoading(true);
        api.get('/dentista', {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then(returnFromApi => {
                setDentists(returnFromApi.data);
                setLoading(false);
            })
            .catch(returnFromApi => {
                setLoading(false);
                console.error("ops! ocorreu um erro", returnFromApi);

                if (returnFromApi.response?.status === 401) {
                    navigate('/expired-session');
                } else {
                    setShowErrorMessage(true);
                    setErrorMessage(returnFromApi.data);
                }
            });
    }, [navigate]);

    useEffect(() => {
        getDentists();
    }, [getDentists]);

    const clickMenu = (event, dentistId) => {
        setAnchorEl(event.currentTarget);
        setSelectedDentistId(dentistId);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    const editDentist = () => {
        const dentistToEdit = dentists.find(d => d.id === selectedDentistId);
        if (dentistToEdit) {
            setSelectedDentist(dentistToEdit);
            setModalOpen(true);
        }
        closeMenu();
    };

    const openConfirmModal = () => {
        setAnchorEl(null);
        setConfirmModalOpen(true);
    };

    const confirmDelete = () => {
        setLoading(true);
        setConfirmModalOpen(false);
        api.delete(`/dentista/${selectedDentistId}`, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then(returnFromApi => {
            setDentists(dentists.filter(dentist => dentist.id !== selectedDentistId));

            setSuccessMessage(returnFromApi.data);
            setShowSuccessMessage(true);
        }).catch(returnFromApi => {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
            console.error("Erro ao excluir o dentista!", returnFromApi);
            if (returnFromApi.response?.status === 401) {
                navigate('/expired-session');
            }
        }).finally(() => {
            setSelectedDentistId(null);
            setLoading(false);
        });
    };

    const closeConfirmModal = () => {
        setConfirmModalOpen(false);
        setSelectedDentistId(null);
    };

    const openCreateModal = () => {
        setSelectedDentist(null);
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
        setSelectedDentist(null);
    };

    function saveDentist(returnFromApi) {
        getDentists();
        closeModal();
        if (returnFromApi.data) {
            setShowSuccessMessage(true);
            setSuccessMessage(returnFromApi.data);
        } else {
            setShowErrorMessage(true);
            setErrorMessage(returnFromApi.response.data);
        }
    };


    return (
        <>
            <Loading isToHidden={isLoading === false} />
            {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
            {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

            <Box sx={{ p: 2 }}>
                <Card sx={{ borderRadius: '16px', boxShadow: 'none' }}>
                    <CardHeader
                        title="Dentistas"
                        titleTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'text.secondary' }}
                    />
                    <CardContent>
                        <List>
                            {dentists.map((dentist) => (
                                <React.Fragment key={dentist.id}>
                                    <ListItem
                                        secondaryAction={
                                            <IconButton onClick={(event) => clickMenu(event, dentist.id)}>
                                                <MoreVertIcon />
                                            </IconButton>
                                        }
                                    >
                                        <ListItemText primary={dentist.nome} />
                                    </ListItem>
                                    <Divider component="li" />
                                </React.Fragment>
                            ))}
                        </List>
                    </CardContent>
                </Card>
            </Box>

            <Fab
                color="primary"
                aria-label="adicionar dentista"
                sx={{
                    position: 'fixed', 
                    bottom: 16,       
                    right: 16,        
                }}
                onClick={openCreateModal}
            >
                <AddIcon />
            </Fab>

            <Menu
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={closeMenu}
            >
                <MenuItem onClick={editDentist}>
                    Editar Dentista
                </MenuItem>
                <MenuItem onClick={openConfirmModal} sx={{ color: 'error.main' }}>
                    Excluir
                </MenuItem>
            </Menu>

            <DentistModal
                open={isModalOpen}
                onClose={closeModal}
                onSave={saveDentist}
                dentist={selectedDentist}
            />

            <Dialog
                open={isConfirmModalOpen}
                onClose={closeConfirmModal}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 'bold' }}>
                    {"Confirmar Exclusão"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Você tem certeza que deseja excluir este dentista? Essa ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmModal}>Cancelar</Button>
                    <Button onClick={confirmDelete} variant="contained" color="error" autoFocus>
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default DentistListMobile;